export default {"src":"/_next/static/media/us.74111a06.svg","height":16,"width":24};